import { get } from 'services/client'

const fetchHome = () => get('stats')

export { fetchHome }
